import {Button, Col, Flex, Row, Breadcrumb} from "antd";
import {HomeOutlined, MenuOutlined} from "@ant-design/icons";
import React from "react";
import {useLocation, useNavigate} from 'react-router-dom';
import {PageContainer} from "@/components/PageContainer/PageContainer";
import {useStore} from "@/store/useStore";
import {ItemType} from "antd/es/breadcrumb/Breadcrumb";
import {getPersonPageRoute, getRootPageRoute, getTransitCentersPageRoute} from "@/routes/routes";
import fbLogo from "@/components/Header/icons/fb_icon.svg";
import xLogo from "@/components/Header/icons/x_icon.svg";
import ytLogo from "@/components/Header/icons/yt_icon.svg";
import breadCrumbSeparator from "@/components/Header/icons/bread_crumb_separator.svg";

export const HeaderBottom = (props: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        isMobile, isTablet, useIncreasedContrastTheme, showSidebar
    } = useStore();

    const exitHandler = () => {
        navigate(location.state?.from || getRootPageRoute(), { replace: true });
    }
    
    const renderBreadcrumbs = () => {
        const itemsList: ItemType[] = [];
        switch (location.pathname) {
            case getRootPageRoute():
                itemsList.push({ title: 'Каталог місць тимчасового проживання' });
                break;
            case getPersonPageRoute():
                itemsList.push({ onClick: exitHandler, title: 'Головна' });
                itemsList.push({ title: 'Картка особи' });
                break;
            case getTransitCentersPageRoute():
                itemsList.push({ onClick: () => navigate(location.state?.from || getRootPageRoute()), title: 'Для ВПО' });
                itemsList.push({ title: 'Транзитні центри' });
                break;
        }
        return (
            <Breadcrumb
                style={{ fontSize: "1.125rem", lineHeight: "1.125rem" }}
                separator={<img src={breadCrumbSeparator} alt='separator'/>}
                items={itemsList}
            />
        )
    }
    
    // const renderSocialNetworksIcons = () => (
    //     <Flex style={{padding: "8px 0"}}>
    //         <Button
    //             type="link"
    //             href="https://www.facebook.com/"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             style={{padding: 0}}
    //         > <img src={fbLogo} alt={'fb'} /> </Button>
    //         <Button
    //             type="link"
    //             href="https://www.facebook.com/"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             style={{padding: 0}}
    //         > <img src={xLogo} alt={'x'} /> </Button>
    //         <Button
    //             type="link"
    //             href="https://www.youtube.com/"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             style={{padding: 0}}
    //         > <img src={ytLogo} alt={'yt'} /> </Button>
    //     </Flex>
    // )
    
    const renderButton = () => (
        <Button
            type="primary"
            icon={<HomeOutlined />}
            style={{
                borderColor: `var(--main-color-white)`,
                color:  `var(--main-color-white)`,
            }}
            onClick={() => location.pathname === getRootPageRoute() 
                ? navigate(getTransitCentersPageRoute(), { state: { from: location.pathname + location.search } })
                : navigate(location.state?.from || getRootPageRoute())
            }
        >
            {location.pathname === getRootPageRoute() ? "Транзитні центри" : "Місця для поселення"}
        </Button>
    )
    
    return (
        <PageContainer
            height={`86px`}
            mainBackgroundColor={useIncreasedContrastTheme ? `var(--main-color-black)` : `var(--main-color-deep-blue)`}
        >
            <Row align="middle" justify="space-between">
                <Col>
                    <Flex gap={16}>
                        {(isMobile || isTablet) && location.pathname === getRootPageRoute() && <MenuOutlined onClick={showSidebar} style={{fontSize: "1.5rem", color: "white"}}/>}
                        {!isMobile && <span style={{color: `var(--main-color-grey)`}}> {renderBreadcrumbs()}</span>}
                    </Flex>
                </Col>
                <Col>
                    {
                        renderButton()
                    }
                </Col>
            </Row>
        </PageContainer>
    )
}